import { AxiosResponse } from 'axios'
import { reactive, UnwrapRef } from '@nuxtjs/composition-api'
import { IError } from '../error'
import { ApiError } from '../api'
import { IApiResponseBase, IApiResponseState } from './api.types'

export function useApiResponse<R>(
  response: AxiosResponse<R & IApiResponseBase> | IError
) {
  const state = reactive<IApiResponseState<R>>({
    isOk: false,
    isError: false,
    isAuthError: false,
    isInvalid: false,
    response,
    data: undefined,
    error: undefined,
  })

  if (response instanceof ApiError) {
    state.error = response
    state.isError = true
  } else {
    const responseRaw = response as AxiosResponse<R & IApiResponseBase>
    state.data = responseRaw.data as UnwrapRef<R & IApiResponseBase>
    switch (responseRaw.status) {
      case 200:
      case 201:
        if (state.data.error) {
          state.isInvalid = true
        } else {
          state.isOk = true
        }
        break
      case 401:
        state.isAuthError = true
        break
    }
  }

  return state
}
